import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ElectronicSharingService } from '../../services/electronic-sharing.service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from '../../../../shared/Services/PagingService';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddElectronicSharingComponent } from '../add-electronic-sharing/add-electronic-sharing.component';
import { GetElectronicSharingDetailsComponent } from '../get-electronic-sharing-details/get-electronic-sharing-details.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ElectronicSharing } from '../../Models/electronic-sharing';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'get-electronic-sharing',
  templateUrl: './get-electronic-sharing.component.html',
  styleUrls: ['./get-electronic-sharing.component.scss']
})
export class GetElectronicSharingComponent extends BaseComponent implements OnInit {
form: FormGroup;
hasUnsavedChanges: boolean = false;
originalOrder: ElectronicSharing[] = [];
isSaving: boolean = false;
totalElementsCount: number = 0;

    constructor(
      public service: ElectronicSharingService,
      route: Router,
      private diag: NbDialogService,
      private toast: NbToastrService,
      private fb: FormBuilder,
      private paging: PagingService
    ) {
      super(route, service, paging);
    }

   ngOnInit() {
      this.intitForm();
      
      this.pagingModel.query.sort = 'orderIndex';
      this.pagingModel.query.sortDirection = 'asc';
      this.loadEntities();
    }

    loadEntities() {
      console.log('Loading electronic sharing entities...');
      if (this.isAuthorized) {
        this.service.get(this.pagingModel.query).subscribe(
          (res) => {
            console.log('Electronic sharing data received:', res);
            this.initiResponse(res);
            this.finishLoading = true;
          },
          (error) => {
            console.error('Error loading electronic sharing data:', error);
            this.finishLoading = true;
          }
        );
      }
    }
  
    intitForm() {
      this.form = this.fb.group({
        titleAR: [''],
      });
    }
  
  handleSearch() {
    if (!this.form.value.titleAR) {
      this.toast.danger('برجاء إدخال العنوان لإتمام عملية البحث', 'رسالة تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.titleAR.trim()) {
      let title = this.form.value.titleAR.trim();
      this.form.controls['titleAR'].setValue(title);
      serchTermArr.push(`titleAR:${title}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
    clearFilter() {
      this.form.controls['titleAR'].setValue('');
      this.loadEntitiesWithFilter('');
    }
  
    addelectronicsharing() {
      this.diag
        .open(AddElectronicSharingComponent, {
          dialogClass: 'custom-dialog-height',
        })
        .onClose.subscribe((res) => {
          if (res === 'true') {
            this.hasUnsavedChanges = false;
            this.loadEntities();
          }
        });
    }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }
  
    detail(model) {
      this.diag.open(GetElectronicSharingDetailsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: model,
        },
      });
    }
  
    update(model) {
      const copymodel = {...model}
      this.diag
        .open(AddElectronicSharingComponent, {
          dialogClass: 'custom-dialog-height',
          context: {
            model: copymodel,
            isEdit: true,
          },
        })
        .onClose.subscribe((res) => {
          if (res === 'true') {
            this.hasUnsavedChanges = false;
            this.loadEntities();
          }
        });
    }
  
    initiResponse(result: any) {
      console.log('Initializing electronic sharing response with data:', result);
      this.pagingModel.responseObj = result.result;
      this.pagingModel.responseData = result;
      this.pagingModel.pager = Array.from({ length: result.totalPages }, (v, k) => k + 1);
      this.pagingModel.totalPages = result.totalPages;
      this.totalElementsCount = this.resolveTotalElements(result);
      
    
      if (this.pagingModel.responseObj && this.pagingModel.responseObj.length > 0) {
        this.pagingModel.responseObj.forEach((item: ElectronicSharing, index: number) => {
          if (!item.orderIndex || item.orderIndex === 0) {
            item.orderIndex = index + 1;
          }
        });
        
       
        this.pagingModel.responseObj.sort((a: ElectronicSharing, b: ElectronicSharing) => {
          const orderA = a.orderIndex || 0;
          const orderB = b.orderIndex || 0;
          return orderA - orderB;
        });
      }
      
      
      this.originalOrder = JSON.parse(JSON.stringify(this.pagingModel.responseObj));
      this.hasUnsavedChanges = false;
      
      console.log('Electronic sharing paging model after init:', this.pagingModel);
      return this.pagingModel;
    }

    drop(event: CdkDragDrop<ElectronicSharing[]>) {
      moveItemInArray(this.pagingModel.responseObj, event.previousIndex, event.currentIndex);
      
     
      this.pagingModel.responseObj.forEach((item: ElectronicSharing, index: number) => {
        item.orderIndex = index + 1;
      });
      
    
      this.hasUnsavedChanges = true;
    }

    saveChanges() {
      if (!this.hasUnsavedChanges) {
        return;
      }

      this.isSaving = true;
      const electronicSharings = this.pagingModel.responseObj.map((item: ElectronicSharing) => {
        return {
          id: item.id,
          titleAR: item.titleAR,
          titleEN: item.titleEN,
          descriptionAR: item.descriptionAR,
          descriptionEN: item.descriptionEN,
          description2AR: item.description2AR,
          description2EN: item.description2EN,
          attachements: item.attachements,
          link: item.link,
          thumbnail: item.thumbnail,
          isExternallink: item.isExternallink,
          isIconEnabled: item.isIconEnabled,
          isVertical: item.isVertical,
          orderIndex: item.orderIndex
        };
      });

      this.service.putBulk(electronicSharings, 'bulk').subscribe(
        () => {
          this.isSaving = false;
          this.hasUnsavedChanges = false;
          this.originalOrder = JSON.parse(JSON.stringify(this.pagingModel.responseObj));
          this.toast.show('تم حفظ تغييرات الترتيب بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          this.isSaving = false;
          console.error('Error updating order:', error);
          this.toast.show('حدث خطأ أثناء حفظ التغييرات', '', { status: 'danger', duration: 3000 });
        }
      );
    }

    viewAll() {
      if (this.isShowingAll()) {
        return;
      }

      const total = this.totalElementsCount
        ? this.totalElementsCount
        : this.pagingModel.responseObj
        ? this.pagingModel.responseObj.length
        : 0;

      if (!total) {
        return;
      }

      this.pagingModel.query.pageSize = total;
      this.pagingModel.query.currentPage = 1;
      this.pagingModel.currentPage = 1;
      this.finishLoading = false;
      this.loadEntities();
    }

    isShowingAll(): boolean {
      if (this.totalElementsCount > 0) {
        return this.pagingModel.query.pageSize >= this.totalElementsCount;
      }
      return false;
    }

    private resolveTotalElements(result: any): number {
      if (!result) {
        return 0;
      }

      const candidateKeys = [
        'totalElements',
        'totalCount',
        'totalRecords',
        'count',
        'total',
        'recordsTotal',
        'recordsFiltered',
      ];

      for (const key of candidateKeys) {
        if (result[key] !== undefined && typeof result[key] === 'number') {
          return result[key];
        }
      }

      if (typeof result.totalPages === 'number' && typeof result.pageSize === 'number') {
        return result.totalPages * result.pageSize;
      }

      if (typeof result.pages === 'number' && typeof result.pageSize === 'number') {
        return result.pages * result.pageSize;
      }

      if (result.result && Array.isArray(result.result)) {
        return result.result.length;
      }

      return 0;
    }


}
